<template>
    <div>
        <div v-if="reviews.length">
            <div class="border mb-3 p-3" v-for="review in reviews" :key="review.id">
                <div><span class="fw-bold lead">{{ review.rate }}</span><span class="small text-muted"> /{{ config.reviews.rate_max_value }}</span></div>
                <div class="fw-bold">{{ truncateText(review.customer.full_name, 8, '***') }}</div>
                <div class="text-muted">{{ review.readableDate }}</div>
                <div class="fst-italic" v-html="nl2br(review.text)"></div>
            </div>
            <div v-if="noMoreReviews" class="small">{{ t.reviews.all_reviews_loaded }}</div>
            <button v-else class="btn btn-secondary" @click="loadMore">Load more</button>
        </div>
        <div v-else>{{ t.reviews.no_reviews }}</div>
    </div>
</template>

<script>
export default {
    props: ['productId'],
    data() {
        return {
            t: t,
            config: config,
            reviews: [],
            page: 1,
            noMoreReviews: false
        };
    },
    mounted() {
        this.loadMore();
    },
    methods: {
        loadMore() {
            axios.get('/ajax/reviews', {
                    params: {
                        'product_id': this.productId,
                        'page': this.page,
                    }
                })
                .then(response => {
                    this.reviews.push(...response.data.data);
                    this.page++;
                    if (response.data.total == this.reviews.length) {
                        this.noMoreReviews = true
                    }
                });
        },
    },
};
</script>
